import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { TestimonialsStrip } from './components/TestimonialsStrip';
import { PainPoints } from './components/PainPoints';
import { SolutionReveal } from './components/SolutionReveal';
import { VolumesSection } from './components/VolumesSection';
import { BonusSection } from './components/BonusSection';
import { PricingSection } from './components/PricingSection';
import { ExtendedTestimonials } from './components/ExtendedTestimonials';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchaseNotifications } from './components/PurchaseNotifications';
import { initMetaPixel, META_PIXEL_ID } from './utils/tracking';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen w-full bg-cream text-charcoal selection:bg-terracotta/20 selection:text-terracotta-deep" data-id="element-0" data-mp="23vul23bheeqe">
      <main data-id="element-1" data-mp="3ij63w8owfj7c">
        <Hero data-id="element-2" data-mp="3ijfthv617oci" />
        <TestimonialsStrip data-id="element-3" data-mp="3ihv0i9zd8dgr" />
        <PainPoints data-id="element-4" data-mp="3mlayb9n68jv1" />
        <SolutionReveal data-id="element-5" data-mp="3mkrgdsxitvh0" />
        <VolumesSection data-id="element-6" data-mp="3mjzu58ptda3e" />
        <BonusSection data-id="element-7" data-mp="3mj6hjr46bqdc" />
        <PricingSection data-id="element-8" data-mp="3rcj846sey78q" />
        <ExtendedTestimonials data-id="element-9" data-mp="3rdas0kcnegj6" />
        <Guarantee data-id="element-10" data-mp="3rd18nfm3z7mg" />
        <FAQ data-id="element-11" data-mp="3relwkmdx3sbc" />
        <FinalCTA data-id="element-12" data-mp="5orh0l86u6j" />
      </main>
      <Footer data-id="element-13" data-mp="4wyzymxdckh" />
      <PurchaseNotifications data-id="element-14" data-mp="5gg5d4r3wxg" />
      <noscript data-id="element-15" data-mp="7stte3h7l4p">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-16" data-mp="2zld259q0hfbj" />
      </noscript>
    </div>;
}